"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _imlog = _interopRequireWildcard(require("@tencent/imlog"));

var _imutils = require("@tencent/imutils");

var _eduCaptcha = _interopRequireDefault(require("@tencent/edu-captcha"));

var _request = _interopRequireDefault(require("./request"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const codeReqParamsKeys = ['app_id', 'scene', 'ticket', 'rand_str', 'nation_code', 'phone_number', 'platform', 'code_type', 'is_phone_encrypted'];
/*
const VerifyCode = new EduVerifyCode({
   appId: '2071124753',
 })

res = await verifyCode.getCode(codeReqParams);
*/

class EduVerifyCode {
  constructor(_options) {
    (0, _defineProperty2.default)(this, "Captcha", void 0);
    (0, _defineProperty2.default)(this, "Logger", void 0);
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "verifyCaptcha", async () => {
      this.Logger.info('invoke show captcha');

      try {
        return await this.Captcha.show();
      } catch (e) {
        this.Logger.error(`verifyCaptcha error: ${e}`);
        return Promise.reject(e);
      }
    });
    (0, _defineProperty2.default)(this, "getCode", (params, options) => {
      const _ref = options || {},
            onVerifyCaptcha = _ref.onVerifyCaptcha,
            onCaptchaCancel = _ref.onCaptchaCancel; // filter params


      let cgiParams = {};
      Object.keys(params).forEach(item => {
        if (codeReqParamsKeys.indexOf(item) === -1) {
          delete params[item];
        }
      });
      params = _objectSpread({
        app_id: 'k12',
        scene: 'k12_login',
        nation_code: '86',
        platform: (0, _imutils.getPlatForm)(),
        code_type: 'text'
      }, params); //  success 、error、 captcha success,  captcha error

      return (0, _request.default)('/cgi-proxy/mobile/send_verify_code', {
        params,
        method: 'POST'
      }).catch(async err => {
        const retcode = err.retcode;

        if (retcode === 539206 && (!params.ticket || !params.rand_str)) {
          try {
            if (onVerifyCaptcha) {
              onVerifyCaptcha();
            }

            const captchaRes = await this.verifyCaptcha();

            if (captchaRes && captchaRes.ret === 0) {
              params.ticket = captchaRes.ticket;
              params.rand_str = captchaRes.randstr;
              return await this.getCode(params);
            } else if (onCaptchaCancel) {
              onCaptchaCancel();
            }

            return err;
          } catch (e) {
            // captcha uncaught error
            this.Logger.error(`getCode captcha catch err: ${e}`);
            throw new Error(e);
          }
        } else {
          //  cgi request error
          // showTips(errMsg || '网络异常，请检查网络环境后重试');
          this.Logger.error(`getCode: ${JSON.stringify(err)}`);
          return Promise.reject(err); // throw new Error(err);
        }
      });
    });
    this.options = Object.assign({}, {
      appId: '2071124753'
    }, _options); // const Logger = imlog.createReportor('edu_verify_code');

    const Logger = _imlog.default.createLogger('@tencent/edu-verify-code').prefix('EduVerifyCodeJS: ');

    Logger.config({
      autoUpload: _imlog.LEVELS.info // project: 'edu-verify-code',
      // logger: { autoUpload: LEVELS.info },
      // uin: `${getUin()}`,

    });
    this.Logger = Logger;
    this.Captcha = new _eduCaptcha.default(this.options.appId);
  }

}

exports.default = EduVerifyCode;